// src/components/DifferentialsSection.jsx
import React, { useRef, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/DifferentialsSection.scss";
import Logo from "../assets/logo.png";
import { FaHandHoldingWater } from "react-icons/fa";
import { FaHouseFloodWater } from "react-icons/fa6";
import { GiWaterGallon } from "react-icons/gi";
import { GiWaterPolo } from "react-icons/gi";

const DIFFS = [
  {
    icon: "/icons/solucao.svg",
    reactI: FaHandHoldingWater,
    title: "Instalação de Sistemas Solares para Aquecimento de Piscinas",
    text: "Transforme sua piscina em um espaço de lazer durante todo o ano com sistemas solares eficientes e sustentáveis.",
    link: { text: "Veja Nossos Produtos para Piscina!", url: "/products" },
  },
  {
    icon: "/icons/projetos.svg",
    reactI: GiWaterPolo,
    title: "Instalação de Bombas de Calor para Piscinas",
    text: "Economize energia enquanto aquece sua piscina com tecnologia avançada de bombas de calor.",
    link: {
      text: "Confira as Bombas de Calor de Última Geração!",
      url: "/calor",
    },
  },
  {
    icon: "/icons/experiencia.svg",
    reactI: GiWaterGallon,
    title: "Instalação de Boilers",
    text: "Garantimos água quente sempre disponível, com instalação e troca de reservatórios térmicos, boilers.",
    link: {
      text: " Clique aqui e Saiba Mais Sobre Boilers e Suas Vantagens!",
      url: "/boiler",
    },
  },
  {
    icon: "/icons/sustentabilidade.svg",
    reactI: FaHouseFloodWater,
    title: "Instalação de Pressurizações",
    text: "Melhore a pressão da sua água com instalação e troca de pressurizadores para sistemas residenciais e comerciais.",
    link: {
      text: "Veja Um Pressurizador de Alta Tecnologia!",
      url: "/bomba",
    },
  },
];

function DiffCard({ diff, delay }) {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <Col md={3} className="diff-card-col">
      <div
        ref={ref}
        className={`diff-card pop-in${visible ? " visible" : ""}`}
        style={{ transitionDelay: `${delay}ms` }}
      >
        <img src={diff.icon} alt="" className="diff-icon" />
        <diff.reactI />
        <h4>{diff.title}</h4>
        <p>{diff.text}</p>
        <a href={diff.link.url} className="diff-link">
          {diff.link.text}
        </a>
      </div>
    </Col>
  );
}

export default function DifferentialsSection() {
  const ref = useRef();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return (
    <section className="differentials-section py-5">
      <Container>
        <div
          className={`diff-card section-header mb-4 pop-in${
            visible ? " visible" : ""
          }`}
          ref={ref}
          style={{ transitionDelay: `${100}ms` }}
        >
          <img src={Logo} alt="ThermalHydro" />
          <h2>Assistência</h2>
          <p className="lead">
            A ThermalHydro é sinônimo de eficiência, confiança e resultado.
            Atuamos com soluções completas em aquecimento e pressurização,
            unindo tecnologia de ponta, economia e sustentabilidade. Nossos
            produtos e serviços são pensados para valorizar o seu investimento e
            garantir a satisfação dos seus clientes. Escolha quem entende do
            assunto. Escolha a ThermalHydro.
          </p>
        </div>
        <Row>
          {DIFFS.map((d, i) => (
            <DiffCard key={i} diff={d} delay={i * 150} />
          ))}
        </Row>
      </Container>
    </section>
  );
}
